var _mask, _path, _path2, _rect, _rect2, _rect3, _rect4, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWeavevmLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 892,
    height: 892,
    viewBox: "0 0 892 892",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_2077_113",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100 0H892V892H0V100H100V0Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100 0H892V892H0V100H100V0Z",
    fill: "#D6D5D5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M892 0V-30H922V0H892ZM100 0H70V-30H100V0ZM892 892H922V922H892V892ZM0 892V922H-30V892H0ZM0 100H-30V70H0V100ZM100 100H130V130H100V100ZM892 30H100V-30H892V30ZM862 892V0H922V892H862ZM0 862H892V922H0V862ZM30 100V892H-30V100H30ZM0 70H100V130H0V70ZM70 100V0H130V100H70Z",
    fill: "black",
    mask: "url(#path-1-inside-1_2077_113)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -15,
    y: 15,
    width: 567,
    height: 448,
    transform: "matrix(-1 0 0 1 765 166)",
    fill: "#0E23F3",
    stroke: "black",
    strokeWidth: 30
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 299,
    height: 30,
    transform: "matrix(-1 0 0 1 731 728)",
    fill: "black"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    transform: "matrix(-1 0 0 1 795 728)",
    fill: "#FF0095"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 130,
    width: 61,
    height: 732,
    fill: "#ABABAB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M567 399C565.933 403.267 565.4 408.6 565.4 415C565.4 421.133 565.933 426.467 567 431H599C600.067 426.467 600.6 421.133 600.6 415C600.6 408.6 600.067 403.267 599 399H615C616.067 394.467 616.6 389.133 616.6 383C616.6 376.6 616.067 371.267 615 367H647C645.933 371.267 645.4 376.6 645.4 383C645.4 389.133 645.933 394.467 647 399H663C661.933 403.267 661.4 408.6 661.4 415C661.4 421.133 661.933 426.467 663 431H695C696.067 426.467 696.6 421.133 696.6 415C696.6 408.6 696.067 403.267 695 399H679C680.067 394.467 680.6 389.133 680.6 383C680.6 376.6 680.067 371.267 679 367H663C664.067 362.467 664.6 357.133 664.6 351C664.6 344.6 664.067 339.267 663 335H647C648.067 330.467 648.6 325.133 648.6 319C648.6 312.6 648.067 307.267 647 303H615C613.933 307.267 613.4 312.6 613.4 319C613.4 325.133 613.933 330.467 615 335H599C597.933 339.267 597.4 344.6 597.4 351C597.4 357.133 597.933 362.467 599 367H583C581.933 371.267 581.4 376.6 581.4 383C581.4 389.133 581.933 394.467 583 399H567ZM302.687 399C301.621 403.267 301.087 408.6 301.087 415C301.087 421.133 301.621 426.467 302.687 431H334.687C335.754 426.467 336.287 421.133 336.287 415C336.287 408.6 335.754 403.267 334.687 399H350.687C351.754 394.467 352.287 389.133 352.287 383C352.287 376.6 351.754 371.267 350.687 367H382.687C381.621 371.267 381.087 376.6 381.087 383C381.087 389.133 381.621 394.467 382.687 399H398.687C397.621 403.267 397.087 408.6 397.087 415C397.087 421.133 397.621 426.467 398.687 431H430.687C431.754 426.467 432.287 421.133 432.287 415C432.287 408.6 431.754 403.267 430.687 399H414.687C415.754 394.467 416.287 389.133 416.287 383C416.287 376.6 415.754 371.267 414.687 367H398.687C399.754 362.467 400.287 357.133 400.287 351C400.287 344.6 399.754 339.267 398.687 335H382.687C383.754 330.467 384.287 325.133 384.287 319C384.287 312.6 383.754 307.267 382.687 303H350.687C349.621 307.267 349.087 312.6 349.087 319C349.087 325.133 349.621 330.467 350.687 335H334.687C333.621 339.267 333.087 344.6 333.087 351C333.087 357.133 333.621 362.467 334.687 367H318.687C317.621 371.267 317.087 376.6 317.087 383C317.087 389.133 317.621 394.467 318.687 399H302.687Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M469 461C467.933 465.267 467.4 470.6 467.4 477C467.4 483.133 467.933 488.467 469 493H549C550.067 488.467 550.6 483.133 550.6 477C550.6 470.6 550.067 465.267 549 461H469Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeavevmLogo);
export default __webpack_public_path__ + "static/media/weavevm-logo.35463a4e7ce447e8ebe20b7ec8dc1c60.svg";
export { ForwardRef as ReactComponent };